<div class="grid m-0" title="{{media.med_titre}}">
	@if (showThumb) {
		<div
			class="col-fixed liste-media-thumb center-all"
			title="{{ media.tym_code | typeMedia}}"
		>
			@switch (media.tym_code) {
				@case ('image') {
					<div class="center-all">
						<media-display [media]="media" [showTitle]="false"></media-display>
					</div>
				}
				@default {
					<media-icon [tym_code]="media.tym_code"></media-icon>
				}
			}
		</div>
	}

	<div class="col flex align-items-center">
		<div class="overflow-hidden text-overflow-ellipsis">
			@if (titleAsLink) {
				<a class="font-bold text-color overflow-hidden  text-overflow-ellipsis" [uiSref]="media._uiSref" [uiParams]="media._uiParams">{{media.med_titre}}</a>
			}

			@if (!titleAsLink) {
				<div class="font-bold overflow-hidden white-space-nowrap text-overflow-ellipsis cursor-pointer" (click)="titleClick()">{{media.med_titre}}</div>
			}

			@if (media.med_fichier) {
				@if (media.med_fichier != media.med_titre) {
					<div class="text-sm">Nom fichier: {{media.med_fichier}}</div>
				}
				@if (showSize) {
					<div class="text-sm">Taille: {{ media.med_taille!|formatSize}}</div>
				}
			}

			@if (['lien', 'video'].includes(media.tym_code) && showLink) {
				<div class="text-sm word-break-all">
					{{media.med_url}}
				</div>
			}

			@if (showId) {
				<div class="text-sm">Id : {{media.med_id}}</div>
				<div class="text-sm">Ajouté le : {{media.med_date_creation|date: 'dd/MM/yy HH:mm:ss'}}</div>
			}
		</div>
	</div>

</div>
